import { Messages } from '../../../codegen/Localize';
import { AuthenticationProviderType } from '../../../settings/siteAuthSettings/services/SiteAuthenticationSettingsService';
import { L10n } from '../../../ts/L10n/L10n';
import { ICheckUserNamesResult, IUserNameAvailability } from '../../../ts/ServerApi/requests/CheckUserNamesRequest';
import { SiteUserAuthSetting } from '../../../ts/ServerApi/types/ISiteUser';
import { AddLocalUserDialogType } from '../../services/AddLocalUserAction';
import { Users } from '../../services/resources/Users';
import { AddLocalUserFormState, IFormModel } from '../AddLocalUsersDialog';

export interface ISetupLocalUserFormModelChanges {
  formModel: IFormModel;
  sitePickerMenuDisabled: boolean;
}

export class SetupLocalUserModelHelper {

  public setupLocalUserFormModel(formModel: IFormModel, userInput: string, addLocalUserDialogType: string, sitePickerMenuDisabled: boolean): Promise<ISetupLocalUserFormModelChanges>{
    let newFormModel: IFormModel = formModel;
    if (!userInput) {
      newFormModel.formState = AddLocalUserFormState.NewUser;
      newFormModel.newUserFlowModel.usernameInfo = '';
      return  Promise.resolve({formModel: newFormModel, sitePickerMenuDisabled: sitePickerMenuDisabled} as ISetupLocalUserFormModelChanges);
    }

    return Users.instance.checkUserNames([userInput]).then((results: ICheckUserNamesResult) => {
      if (results.users.length === 0) {
        newFormModel.formState = AddLocalUserFormState.Initial;
        return {formModel: newFormModel, sitePickerMenuDisabled: sitePickerMenuDisabled} as ISetupLocalUserFormModelChanges;
      }

      const result: IUserNameAvailability = results.users[0];
      let isSitePickerMenuDisabled = sitePickerMenuDisabled;

      // $note-ltan:
      // We can not assume we are dealing with site users even when existsOnSite is true.
      // Thus the explicity mode check.
      if (addLocalUserDialogType === AddLocalUserDialogType.SITE && result.existsOnSite) {
        const error = Messages.usernameExistsOnCurrentSite({ USER_NAME: L10n.elideIfLong(result.displayName) });
        newFormModel = this.setupFormForNotAvailable(result.displayName, error, newFormModel);
      } else if (result.existsOnServer) {
        if (addLocalUserDialogType === AddLocalUserDialogType.SITE) {
          if ((result.userAuthSetting === SiteUserAuthSetting.Default) && (formModel.authenticationProviderSelectorProperties.authenticationProvider.type === AuthenticationProviderType.default)) {
            newFormModel = this.setupFormForAddUserToSite(result.displayName, newFormModel);
            isSitePickerMenuDisabled = true;
          } else {
            const error = Messages.userNameExistsOnServerForAddUserToSiteSAML({ USER_NAME: L10n.elideIfLong(result.displayName) });
            newFormModel = this.setupFormForNotAvailable(result.displayName, error, newFormModel);
          }
        } else {
          if (result.userAuthSetting === SiteUserAuthSetting.Default) {
            const error = Messages.usernameExistsOnServer({ USER_NAME: L10n.elideIfLong(result.displayName) });
            newFormModel = this.setupFormForNotAvailable(result.displayName, error, newFormModel);
          } else {
            const error = Messages.userNameExistsOnServerForAddUserToSiteSAML({ USER_NAME: L10n.elideIfLong(result.displayName) });
            newFormModel = this.setupFormForNotAvailable(result.displayName, error, newFormModel);
          }
        }
      } else {
        newFormModel = this.setupFormForAvailable(newFormModel);
        isSitePickerMenuDisabled = false;
      }
      newFormModel.username = userInput;
      return {formModel: newFormModel, sitePickerMenuDisabled: isSitePickerMenuDisabled} as ISetupLocalUserFormModelChanges;
    });
  }

  public setupFormForNotAvailable(displayName: string, error: string, formModel: IFormModel): IFormModel {
    let newFormModel: IFormModel = formModel;
    newFormModel.formState = AddLocalUserFormState.NotAvailable;
    newFormModel.notAvailableFlowModel.displayName = displayName;
    newFormModel.notAvailableFlowModel.errorText = error;
    return newFormModel;
  }

  public setupFormForAddUserToSite(displayName: string, formModel: IFormModel): IFormModel {
    let newFormModel: IFormModel = formModel;
    newFormModel.formState = AddLocalUserFormState.OtherSite;
    newFormModel.otherSiteFlowModel.displayName = displayName;
    newFormModel.otherSiteFlowModel.warningText = Messages.usernameExistsOnAnotherSite({USER_NAME: L10n.elideIfLong(displayName)});
    newFormModel.otherSiteFlowModel.proceedClicked = false;
    return newFormModel;
  }

  public setupFormForAvailable(formModel: IFormModel): IFormModel {
    let newFormModel: IFormModel = formModel;
    newFormModel.formState = AddLocalUserFormState.NewUser;
    newFormModel.newUserFlowModel.usernameInfo = Messages.usernameAvailable();
    return newFormModel;
  }
}


